// import React from 'react'


import { configureStore } from "@reduxjs/toolkit";
import Offer from "../Slice/Offer";
import BLM from "../Slice/BLMSlice";


export const store = configureStore({
    reducer: {
        app: Offer,
        blmUsers: BLM
    },
});